var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTreebulalogo = function SvgTreebulalogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#treebulalogo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DFFF5D",
    d: "m22.14 14.289 7.247-7.248-4.029-4.03-7.248 7.228V0H12.4v10.239L5.15 2.99 1.12 7.04l7.249 7.248H0V20h9.346a5.71 5.71 0 0 0 5.711-5.711h-4.943v-.374a4.94 4.94 0 0 0 4.943-4.943h.374a4.94 4.94 0 0 0 4.943 4.943v.374H15.43A5.71 5.71 0 0 0 21.142 20h9.346v-5.711z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "treebulalogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30.509v20H0z"
  })))));
};
export default SvgTreebulalogo;